import { ConfirmationType } from '@/entities/confirmationType/@/tour';
import { isTravelataOperatorId } from '@/entities/operator/@/tour';
import { HotelAvailable } from '@/entities/product/@/tour';
import { FlightType, type TourConfirmationSource } from '../model/types';

/**
 * Тип подтверждения тура. Места в продаже — оператор подтвердит сразу; тур по запросу
 * оператор подтверждает вручную, и насколько это рискованно, решает перелёт: у чартера место
 * держится за туроператором, у регулярного рейса его может не оказаться.
 *
 * Порядок веток значим: у Травелаты тур по запросу всегда «долгий», даже на регулярном рейсе.
 */
export function getTourConfirmationType(source: TourConfirmationSource): ConfirmationType | null {
  const { hotelAvailable, operatorId, flightType } = source;
  if (hotelAvailable === HotelAvailable.All) return ConfirmationType.Quick;
  if (hotelAvailable !== HotelAvailable.ByRequest) return null;
  if (operatorId !== null && isTravelataOperatorId(operatorId)) return ConfirmationType.Long;

  return flightType === FlightType.Regular ? ConfirmationType.Cancel : ConfirmationType.Long;
}
